export type OfferType = 'discount' | 'free_gift'

export interface GiftProduct {
	/** Absolute URL or root-relative path, e.g. "/images/gift/ilia.jpg" */
	image: string
	brand: string
	name: string
	description: string
	/** Display string, e.g. "$28" */
	value: string
}

export interface GetStartedOffer {
	type: OfferType
	authTeaser: string
	unlockedMessage: string
	/** Coupon code to copy at checkout — discount type only */
	couponCode?: string | null
	/** Shopify product handle for the gift item — free_gift type only */
	giftProductHandle?: string | null
	/** Resolved variant GID for adding to cart — populated server-side from giftProductHandle */
	giftVariantId?: string | null
	/** Display text for the gift value, e.g. "$200" — free_gift type only */
	giftValueText?: string | null
	/** Individual products that make up the free gift bundle — free_gift type only */
	giftProducts?: GiftProduct[] | null
	/** Label shown on the annual card gift section, e.g. "Free Gift Included" */
	giftCardLabel?: string | null
	/** Subtext shown on the annual card after the value, e.g. "in luxury beauty" */
	giftCardSubtext?: string | null
	/** CTA button text on the annual card, e.g. "See what's inside →" */
	giftCardCta?: string | null
	/** Heading shown in the gift modal, e.g. "Your Free Gift" */
	giftModalHeading?: string | null
	/** Subtext shown in the gift modal below the heading */
	giftModalSubtext?: string | null
	/** Disclaimer shown at the bottom of the gift modal */
	giftModalDisclaimer?: string | null
	/** Subheadline shown on the plan selection step when this offer is active */
	planSubheadline?: string | null
	/** Callout text shown on the annual plan card when this offer is active */
	annualCallout?: string | null
	/** Suffix appended to the annual badge pill after the base tag, e.g. "20% off 1st box" */
	annualTagSuffix?: string | null
}

/** Shown in the gift modal when Prismic hasn't configured giftProducts yet */
export const FALLBACK_GIFT_PRODUCTS: GiftProduct[] = [
	{
		image: '/images/gift/ilia.jpg',
		brand: 'ILIA',
		name: 'In Frame Brow Gel',
		description: 'Clear, lightweight brow gel that sculpts and sets for a full, lifted look. Clinically proven to hold for 8 hours with a natural, flake-resistant finish.',
		value: '$29'
	},
	{
		image: '/images/gift/dr-barbara-sturm-face-cream-rich.jpg',
		brand: 'Dr. Barbara Sturm',
		name: 'Face Cream Rich',
		description: 'This gentle foaming cleanser removes complexion makeup and other impurities and prepares your skin for moisturizer or serum, without disturbing the delicate pH-balance or skin barrier function.',
		value: '$80'
	},
	{
		image: '/images/gift/clearstem-bounceback.jpg',
		brand: 'CLEARSTEM',
		name: 'BOUNCEBACK Fine Lines Serum',
		description: "Our 'no tox' tri-peptide serum visibly reduces fine lines, boosts collagen, and plumps skin—without pore-clogging ingredients.",
		value: '$29'
	}
]

